import { connect } from 'react-redux';
import ProductDetailsApp from './productDetailsApp';
import { getClassificationProperty, getSizeData } from './productDetailsUtils';

const mapStateToProps = ({ detailsPage }) => {
  const { selectedSize, loadedProduct, productNotFoundContent, disableNotifyMe } = detailsPage;
  const {
    imageSet,
    name,
    classificationData,
    description,
    price,
    priceValue,
    heroBadges,
    promoBadges,
    relatedPageTitle,
    relatedPageUrl,
    relatedPageLinkColor,
  } = loadedProduct;
  const product404ImageSrc = 'https://i8.amplience.net/i/fitflop/404?fmt=auto&qlt=default';

  const productDetails = {
    productNotFoundContent,
    selectedSize,
    hasStock: true,
    sizes: getSizeData(loadedProduct),
    heroImage: (imageSet && imageSet.items && imageSet.items[0].src) || product404ImageSrc,
    name,
    colourName: getClassificationProperty(classificationData, 'color'),
    description,
    priceValue,
    price,
    heroBadges,
    promoBadges,
    disableNotifyMe,
    productType: detailsPage.productType,
    relatedPageTitle,
    relatedPageUrl,
    relatedPageLinkColor,
  };

  return { productDetails };
};

export default connect(mapStateToProps)(ProductDetailsApp);
